"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: crypto/crypto.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcrypto%2Fcrypto.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroHashAccountDetailsZeroHashAccountTypeToJSON = exports.zeroHashAccountDetailsZeroHashAccountTypeFromJSON = exports.eligibilityRequirementTypeToJSON = exports.eligibilityRequirementTypeFromJSON = exports.EligibilityRequirements = exports.EligibilityRequirement = exports.ExternalAccount = exports.ZeroHashAccountDetails = exports.Total = exports.Quantity = exports.ZeroHashAccountDetailsZeroHashAccountType = exports.EligibilityRequirementType = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.crypto.proto';
var EligibilityRequirementType;
(function (EligibilityRequirementType) {
    EligibilityRequirementType["INVALID_REQUIREMENT_TYPE"] = "INVALID_REQUIREMENT_TYPE";
    EligibilityRequirementType["REGION"] = "REGION";
    EligibilityRequirementType["SSN"] = "SSN";
    EligibilityRequirementType["AGE"] = "AGE";
    EligibilityRequirementType["KYC"] = "KYC";
    EligibilityRequirementType["AUTHORIZATION"] = "AUTHORIZATION";
    EligibilityRequirementType["IDENTITY_CHECK"] = "IDENTITY_CHECK";
    EligibilityRequirementType["EMAIL"] = "EMAIL";
    EligibilityRequirementType["AUTHORIZED_USER_EMAIL"] = "AUTHORIZED_USER_EMAIL";
    EligibilityRequirementType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(EligibilityRequirementType || (exports.EligibilityRequirementType = EligibilityRequirementType = {}));
/**
 * ZeroHash account types: https://zerohash.com/api/web/#account-type
 */
var ZeroHashAccountDetailsZeroHashAccountType;
(function (ZeroHashAccountDetailsZeroHashAccountType) {
    ZeroHashAccountDetailsZeroHashAccountType["INVALID_TYPE"] = "INVALID_TYPE";
    ZeroHashAccountDetailsZeroHashAccountType["AVAILABLE"] = "AVAILABLE";
    ZeroHashAccountDetailsZeroHashAccountType["COLLATERAL"] = "COLLATERAL";
    ZeroHashAccountDetailsZeroHashAccountType["PAYABLE"] = "PAYABLE";
    ZeroHashAccountDetailsZeroHashAccountType["RECEIVABLE"] = "RECEIVABLE";
    ZeroHashAccountDetailsZeroHashAccountType["COLLATERAL_DEFICIENCY"] = "COLLATERAL_DEFICIENCY";
    ZeroHashAccountDetailsZeroHashAccountType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ZeroHashAccountDetailsZeroHashAccountType || (exports.ZeroHashAccountDetailsZeroHashAccountType = ZeroHashAccountDetailsZeroHashAccountType = {}));
function createBaseQuantity() {
    return { amount: amount_1.Amount.fromPartial({}) };
}
exports.Quantity = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.Quantity.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuantity();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseTotal() {
    return { currency: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.Total = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.Total.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTotal();
        message.currency = object.currency ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseZeroHashAccountDetails() {
    return {
        type: ZeroHashAccountDetailsZeroHashAccountType.INVALID_TYPE,
        accountGroup: '',
        accountLabel: '',
        accountOwner: '',
    };
}
exports.ZeroHashAccountDetails = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? zeroHashAccountDetailsZeroHashAccountTypeFromJSON(object.type)
                : ZeroHashAccountDetailsZeroHashAccountType.INVALID_TYPE,
            accountGroup: isSet(object.accountGroup) ? globalThis.String(object.accountGroup) : '',
        };
        if (isSet(object.accountLabel)) {
            message.accountLabel = globalThis.String(object.accountLabel);
        }
        if (isSet(object.accountOwner)) {
            message.accountOwner = globalThis.String(object.accountOwner);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== ZeroHashAccountDetailsZeroHashAccountType.INVALID_TYPE) {
            obj.type = zeroHashAccountDetailsZeroHashAccountTypeToJSON(message.type);
        }
        if (message.accountGroup !== '') {
            obj.accountGroup = message.accountGroup;
        }
        if (message.accountLabel !== undefined && message.accountLabel !== '') {
            obj.accountLabel = message.accountLabel;
        }
        if (message.accountOwner !== undefined && message.accountOwner !== '') {
            obj.accountOwner = message.accountOwner;
        }
        return obj;
    },
    create(base) {
        return exports.ZeroHashAccountDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseZeroHashAccountDetails();
        message.type = object.type ?? ZeroHashAccountDetailsZeroHashAccountType.INVALID_TYPE;
        message.accountGroup = object.accountGroup ?? '';
        message.accountLabel = object.accountLabel ?? '';
        message.accountOwner = object.accountOwner ?? '';
        return message;
    },
};
function createBaseExternalAccount() {
    return {
        referenceId: '',
        balance: amount_1.Amount.fromPartial({}),
        updatedAtMs: '0',
        zeroHash: undefined,
    };
}
exports.ExternalAccount = {
    fromJSON(object) {
        const message = {
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            balance: isSet(object.balance) ? amount_1.Amount.fromJSON(object.balance) : amount_1.Amount.fromPartial({}),
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.zeroHash)) {
            message.zeroHash = exports.ZeroHashAccountDetails.fromJSON(object.zeroHash);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.balance !== undefined) {
            obj.balance = amount_1.Amount.toJSON(message.balance);
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.zeroHash !== undefined) {
            obj.zeroHash = exports.ZeroHashAccountDetails.toJSON(message.zeroHash);
        }
        return obj;
    },
    create(base) {
        return exports.ExternalAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExternalAccount();
        message.referenceId = object.referenceId ?? '';
        message.balance = (object.balance !== undefined && object.balance !== null)
            ? amount_1.Amount.fromPartial(object.balance)
            : amount_1.Amount.fromPartial({});
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.zeroHash = (object.zeroHash !== undefined && object.zeroHash !== null)
            ? exports.ZeroHashAccountDetails.fromPartial(object.zeroHash)
            : undefined;
        return message;
    },
};
function createBaseEligibilityRequirement() {
    return { confirmed: false, type: EligibilityRequirementType.INVALID_REQUIREMENT_TYPE };
}
exports.EligibilityRequirement = {
    fromJSON(object) {
        const message = {
            confirmed: isSet(object.confirmed) ? globalThis.Boolean(object.confirmed) : false,
            type: isSet(object.type)
                ? eligibilityRequirementTypeFromJSON(object.type)
                : EligibilityRequirementType.INVALID_REQUIREMENT_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.confirmed !== false) {
            obj.confirmed = message.confirmed;
        }
        if (message.type !== EligibilityRequirementType.INVALID_REQUIREMENT_TYPE) {
            obj.type = eligibilityRequirementTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.EligibilityRequirement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEligibilityRequirement();
        message.confirmed = object.confirmed ?? false;
        message.type = object.type ?? EligibilityRequirementType.INVALID_REQUIREMENT_TYPE;
        return message;
    },
};
function createBaseEligibilityRequirements() {
    return { requirements: [] };
}
exports.EligibilityRequirements = {
    fromJSON(object) {
        const message = {
            requirements: globalThis.Array.isArray(object?.requirements)
                ? object.requirements.map((e) => exports.EligibilityRequirement.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requirements?.length) {
            obj.requirements = message.requirements.map((e) => exports.EligibilityRequirement.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EligibilityRequirements.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEligibilityRequirements();
        message.requirements = object.requirements?.map((e) => exports.EligibilityRequirement.fromPartial(e)) ||
            [];
        return message;
    },
};
function eligibilityRequirementTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REQUIREMENT_TYPE':
            return EligibilityRequirementType.INVALID_REQUIREMENT_TYPE;
        case 1:
        case 'REGION':
            return EligibilityRequirementType.REGION;
        case 2:
        case 'SSN':
            return EligibilityRequirementType.SSN;
        case 3:
        case 'AGE':
            return EligibilityRequirementType.AGE;
        case 4:
        case 'KYC':
            return EligibilityRequirementType.KYC;
        case 5:
        case 'AUTHORIZATION':
            return EligibilityRequirementType.AUTHORIZATION;
        case 6:
        case 'IDENTITY_CHECK':
            return EligibilityRequirementType.IDENTITY_CHECK;
        case 7:
        case 'EMAIL':
            return EligibilityRequirementType.EMAIL;
        case 8:
        case 'AUTHORIZED_USER_EMAIL':
            return EligibilityRequirementType.AUTHORIZED_USER_EMAIL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return EligibilityRequirementType.UNRECOGNIZED;
    }
}
exports.eligibilityRequirementTypeFromJSON = eligibilityRequirementTypeFromJSON;
function eligibilityRequirementTypeToJSON(object) {
    switch (object) {
        case EligibilityRequirementType.INVALID_REQUIREMENT_TYPE:
            return 'INVALID_REQUIREMENT_TYPE';
        case EligibilityRequirementType.REGION:
            return 'REGION';
        case EligibilityRequirementType.SSN:
            return 'SSN';
        case EligibilityRequirementType.AGE:
            return 'AGE';
        case EligibilityRequirementType.KYC:
            return 'KYC';
        case EligibilityRequirementType.AUTHORIZATION:
            return 'AUTHORIZATION';
        case EligibilityRequirementType.IDENTITY_CHECK:
            return 'IDENTITY_CHECK';
        case EligibilityRequirementType.EMAIL:
            return 'EMAIL';
        case EligibilityRequirementType.AUTHORIZED_USER_EMAIL:
            return 'AUTHORIZED_USER_EMAIL';
        case EligibilityRequirementType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.eligibilityRequirementTypeToJSON = eligibilityRequirementTypeToJSON;
function zeroHashAccountDetailsZeroHashAccountTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TYPE':
            return ZeroHashAccountDetailsZeroHashAccountType.INVALID_TYPE;
        case 1:
        case 'AVAILABLE':
            return ZeroHashAccountDetailsZeroHashAccountType.AVAILABLE;
        case 2:
        case 'COLLATERAL':
            return ZeroHashAccountDetailsZeroHashAccountType.COLLATERAL;
        case 3:
        case 'PAYABLE':
            return ZeroHashAccountDetailsZeroHashAccountType.PAYABLE;
        case 4:
        case 'RECEIVABLE':
            return ZeroHashAccountDetailsZeroHashAccountType.RECEIVABLE;
        case 5:
        case 'COLLATERAL_DEFICIENCY':
            return ZeroHashAccountDetailsZeroHashAccountType.COLLATERAL_DEFICIENCY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ZeroHashAccountDetailsZeroHashAccountType.UNRECOGNIZED;
    }
}
exports.zeroHashAccountDetailsZeroHashAccountTypeFromJSON = zeroHashAccountDetailsZeroHashAccountTypeFromJSON;
function zeroHashAccountDetailsZeroHashAccountTypeToJSON(object) {
    switch (object) {
        case ZeroHashAccountDetailsZeroHashAccountType.INVALID_TYPE:
            return 'INVALID_TYPE';
        case ZeroHashAccountDetailsZeroHashAccountType.AVAILABLE:
            return 'AVAILABLE';
        case ZeroHashAccountDetailsZeroHashAccountType.COLLATERAL:
            return 'COLLATERAL';
        case ZeroHashAccountDetailsZeroHashAccountType.PAYABLE:
            return 'PAYABLE';
        case ZeroHashAccountDetailsZeroHashAccountType.RECEIVABLE:
            return 'RECEIVABLE';
        case ZeroHashAccountDetailsZeroHashAccountType.COLLATERAL_DEFICIENCY:
            return 'COLLATERAL_DEFICIENCY';
        case ZeroHashAccountDetailsZeroHashAccountType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.zeroHashAccountDetailsZeroHashAccountTypeToJSON = zeroHashAccountDetailsZeroHashAccountTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=crypto.js.map